import { render } from "./Purchase_edit.vue?vue&type=template&id=9bc934f0"
import script from "./Purchase_edit.vue?vue&type=script&lang=js"
export * from "./Purchase_edit.vue?vue&type=script&lang=js"

import "./Purchase_edit.vue?vue&type=style&index=0&id=9bc934f0&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__